import { ScrollArea } from "@/components/flexkit/ScrollArea";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/flexkit/tables/Table";
import { Text } from "@/components/podkit/typography/Text";
import { Frown, Loader2 } from "lucide-react";
import type { FC, ReactNode } from "react";

type Props = {
    title: string;
    subtitle: string;
    rows: { key: string; title: ReactNode; time: string }[];
    isLoading?: boolean;
    onScrollEnd?: () => void;
};
export const InsightsTopTable: FC<Props> = ({ title, subtitle, rows, isLoading, onScrollEnd }) => {
    return (
        <div className="w-full rounded-xl border-0.5 border-border-base">
            <header className="p-4">
                <Text className="text-base font-bold">{title}</Text>
                <Text className="text-sm text-content-secondary">{subtitle}</Text>
            </header>
            {isLoading && rows.length === 0 ? (
                <div className="flex h-64 items-center justify-center">
                    <Loader2 className="size-4 animate-spin" />
                </div>
            ) : (
                <ScrollArea orientation="vertical" className="h-64" onScrollEnd={onScrollEnd} scrollEndThreshold={200}>
                    <Table className="table-fixed">
                        <TableHeader className="h-8 [&_th]:border-border-base [&_th]:border-b-[0.5] [&_th]:bg-transparent [&_th]:py-1">
                            <TableRow className="border-b-0.5 border-t-0.5 last:border-solid">
                                <TableHead className="w-3/4 text-sm font-bold text-content-secondary">Name</TableHead>
                                <TableHead className="w-1/4 text-right text-sm font-bold text-content-secondary">
                                    Time
                                </TableHead>
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {rows.map((row) => (
                                <TableRow className="border-b-0.5" key={row.key}>
                                    <TableCell>{row.title}</TableCell>
                                    <TableCell className="text-right">{row.time}</TableCell>
                                </TableRow>
                            ))}
                            {isLoading && (
                                <TableRow className="border-b-0.5">
                                    <TableCell className="flex items-center gap-2">
                                        <Loader2 className="size-4 animate-spin" />
                                    </TableCell>
                                </TableRow>
                            )}
                            {rows.length === 0 && (
                                <TableRow className="mt-16 w-full border-none pt-5">
                                    <TableCell colSpan={2} className="w-full p-4 text-center">
                                        <div className="mt-4 flex w-full flex-col items-center justify-center gap-2">
                                            <Frown className="size-8" />
                                            <span className="text-center text-base">
                                                No data available for the selected time range
                                            </span>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </ScrollArea>
            )}
        </div>
    );
};
